import { computed } from 'mobx';

import { clientStore } from 'apps/client/app';

import { maxWidths } from 'legacyComponents/styled/styleUtils';

export class OneColumnLayout {
  @computed get layoutSpec() {
    return { cardColumns: 1, initialRows: 5, extraRows: 10 };
  }

  @computed get initialBatchSize() {
    return this.layoutSpec.initialRows * this.layoutSpec.cardColumns;
  }

  @computed get batchSize() {
    return this.layoutSpec.extraRows * this.layoutSpec.cardColumns;
  }
}

export class ThreeColumnLayout {
  // FIXME - return a default layout
  // eslint-disable-next-line getter-return, consistent-return
  @computed get layoutSpec() {
    if (clientStore.windowWidth >= maxWidths.m) {
      return { cardColumns: 3, initialRows: 1, extraRows: 2 };
    }
    if (clientStore.windowWidth < maxWidths.m) {
      return { cardColumns: 2, initialRows: 2, extraRows: 10 };
    }
    if (clientStore.windowWidth < maxWidths.xs) {
      return { cardColumns: 1, initialRows: 3, extraRows: 10 };
    }
  }

  @computed get initialBatchSize() {
    return this.layoutSpec.initialRows * this.layoutSpec.cardColumns;
  }

  @computed get batchSize() {
    return this.layoutSpec.extraRows * this.layoutSpec.cardColumns;
  }
}

export class SmallThreeColumnLayout {
  @computed get layoutSpec() {
    if (clientStore.windowWidth >= maxWidths.m) {
      return { cardColumns: 3 };
    }
    if (clientStore.windowWidth < maxWidths.m) {
      return { cardColumns: 2 };
    }
    if (clientStore.windowWidth < maxWidths.xs) {
      return { cardColumns: 1 };
    }
    return { cardColumns: 3 };
  }

  @computed get initialBatchSize() {
    return this.layoutSpec.initialRows * this.layoutSpec.cardColumns;
  }

  @computed get batchSize() {
    return this.layoutSpec.extraRows * this.layoutSpec.cardColumns;
  }
}
